import {Injectable} from '@angular/core';


export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}
  let MENUITEMS;

@Injectable()
export class MenuItems {
  private _menu = []
  getAll(): Menu[] {
    return MENUITEMS;
  }
  setAll(menu):void{
    MENUITEMS = menu
  }
  reset():void{
    MENUITEMS = []
  }

  contruirMenu(lista){
    let menu = []
    this.recorrer(lista, menu, null, 0, 0, 0, null)
    console.log("menu final",menu)
    this.setAll(menu)
    
  }

  private recorrer(lista, menu, padre, nivel, elemet, previous, menuElement){
    let hijos = this.hijos(lista,padre)
    nivel = nivel + 1
    if(hijos.length > 0){
      let count = 0
      for(let hijo of hijos){
        let item
        if(nivel == 1){
          menu.push({label: hijo.descripcion,main :[], padre:padre})
          item = menu[count]
        }
        if(nivel == 2){
          menu[elemet].main.push(this.estructura(hijo,padre))
          item = menu[elemet].main[count]
        }
        if(nivel == 3 ) {
          menu[previous].main[elemet].children.push(this.estructura(hijo,padre))
          item = menu[previous].main[elemet].children[count]
        }
        if(nivel >= 4 ) {
          menuElement.children.push(this.estructura(hijo,padre))
        }
        this.recorrer(lista, menu,hijo.id, nivel, count, elemet, item)
        count ++
      }
      if(nivel == 3 && menu[previous].main[elemet].children.length > 0) menu[previous].main[elemet].type = 'sub'
      if(nivel >= 4 && menuElement.children.length > 0) menuElement.type = 'sub'

    }else{
      return null
    }
  }

  private hijos(lista, padre){
    let hijos = [];
    hijos = lista.filter(function(item){
      if(item.adm_menu_id == padre)
        return item
    })
    return hijos 
  }

  private estructura(item, padre){
      let children = { 
        state: item.path,
        short_label: 'B',
        name: item.descripcion,
        type: 'link',
        icon: item.icono_menu, 
        padre: padre,
        parametro: item.path_parametro,
        children:[]
      }
      
      if(item.path_auxiliar != null){
        children['main_state'] = item.path,
        children.state  = item.path_auxiliar
      }
      return children
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/menu-items/menu-items.ts